import React from 'react';
import MaskedInput from 'react-text-mask';
import SVG from 'react-inlinesvg';
import axios from 'axios';
import { toggleFormsModal } from '../../actions';
import { connect } from 'react-redux';

import './index.css';
import Button from '../../components/button';
import downloadIcon from '../../images/download.svg';
import deleteIcon from '../../images/file-delete.svg';

axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';

class FormIdea extends React.Component {
  state = {
    phone: '',
    text: '',
    user: '',
    file: null,
    filename: null,
    touched: {
      phone: false,
      comment: false,
      name: false
    },
    valid: {
      phone: false,
      name: false
    }
  }

  handleTouched = (label) => {
    this.setState({
      touched: {
        ...this.state.touched,
        [label]: true
      }
    })
  }

  handleInput = (e, label) => {
    this.setState({
      [label]: e.target.value,
    }, () => this.checkInputsValidity())
  }

  checkInputsValidity = () => {
    this.setState({
      valid: {
        phone: this.state.phone.length > 0,
        user: this.state.user.length > 1
      }
    })
  }

  formIsValid = () => {
    return Object.values(this.state.valid).filter(validity => validity === true).length === Object.values(this.state.valid).length;
  }

  submitApplication = (event) => {
    event.preventDefault();
    if (this.formIsValid()) {
      const form = {
        user: this.state.user,
        phone: this.state.phone,
        text: this.state.text,
        file: this.state.file
      }
      const data = new FormData();
      data.append("user", form.user);
      data.append("phone", form.phone);
      data.append("text", form.text);
      data.append("file", form.file);
      axios.post("/api/v1/sendmail/idea", data)
        .then(response => console.log(1));
        this.props.toggleFormsModal(true, 'thanksPage')
    }
  }
  handleFileInput = (event) => {
    event.persist();

    let fileNameShort = event.target.files[0].name.slice(0,20)
    this.setState({ file: event.target.files[0], filename: fileNameShort + '...' });
  }

  handleFileDelete = () => {
    this.setState({ file: null, filename: null })
    document.getElementById("file").value = "";
  }
  render() {
    return (
      <div className={["idea",
        (this.props.theme === 'dark') ? 'idea__dark' : ''].join(' ')}>
        <div className="idea__container" id="formidea">
    <h2 className={["idea__title", (this.props.theme === 'dark') ? 'idea__title__dark' : ''].join(' ')}>
      { localStorage.getItem('lang') == 'ru'? 'Давайте обсудим ваш проект':'Let`s discuss your idea'}</h2>
          <div className={["idea__container__text", (this.props.theme === 'dark') ? 'idea__container__text__dark' : ''].join(' ')}>
            { localStorage.getItem('lang') == 'ru'? 'Сделаем вашу идею реальной':'and make it real'}</div>
          <form>
            <div className="idea__input-wrapper">
              <input
                className={["idea__input", (this.props.theme === 'dark') ? 'idea__input__dark' : '',
                  this.state.touched.name && !this.state.valid.name ? "idea__input-invalid" : ""].join(' ')}
                name="username"
                type="text"
                onChange={(e) => this.handleInput(e, 'user')}
                onBlur={() => this.handleTouched('user')}
                required
                placeholder={ localStorage.getItem('lang') == 'ru'? 'Имя*':'Name'} />
              <input
                mask={['+', '7', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                // showMask={true}
                keepCharPositions={false}
                onBlur={() => this.handleTouched('phone')}
                className={["idea__input", (this.props.theme === 'dark') ? 'idea__input__dark' : '',
                  this.state.touched.phone && !this.state.valid.phone ? "idea__input-invalid" : ""].join(' ')}
                onChange={(e) => this.handleInput(e, 'phone')}
                name="phone"
                required
                type="tel"
                placeholder={localStorage.getItem('lang') == 'ru'? 'Телефон':'Mobile phone or email'} />
              <textarea
                className={["idea__input-comment", (this.props.theme === 'dark') ? 'idea__input-comment__dark' : ''].join(' ')}
                name="text"
                onChange={(e) => this.handleInput(e, 'text')}
                placeholder={localStorage.getItem('lang') == 'ru'? 'Комментарии':'Your comment'}></textarea>
              <div className={["idea__download__content idea__input-file__wrapper"].join(" ")}>
                <input
                  id="file"
                  onChange={this.handleFileInput}
                  type="file"
                  name="file"
                  className={["idea__input-file", this.props.theme === 'dark' ? 'idea__input-file__dark' : ''].join(' ')} />
                <img
                  className="idea__download__content-contact"
                  src={downloadIcon}
                  alt="" />
                <div className={["idea__input-file__button", this.props.theme === 'dark' ? "idea__input-file__button-dark" : ""].join(" ")}>
                {localStorage.getItem('lang') == 'ru'? 'Загрузить файл':'Select file'}
                </div>
                {this.state.filename ?
                  <span className={["idea__input-file__name", this.props.theme === 'dark' ? "idea__input-file__name-dark" : ""].join(" ")}>{this.state.filename}</span> :
                  <span className={["idea__input-file__name", this.props.theme === 'dark' ? "idea__input-file__name-dark" : ""].join(" ")}>{localStorage.getItem('lang') == 'ru'? 'Выберите файл':'Specs.doc'}</span>}
                {this.state.file ?
                  <div
                    onClick={this.handleFileDelete}
                    className={["idea__download__content__delete", this.props.theme === 'dark' ? "idea__download__content__delete-dark" : ""].join(" ")} >
                    <SVG src={deleteIcon} />
                  </div> : null}
              </div>
            </div>
            <div className="idea__button-wrapper">
              <Button handler={this.submitApplication}>{localStorage.getItem('lang') == 'ru'? 'Отправить':'Send'}</Button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    toggleFormsModal: (flag, tab) => dispatch(toggleFormsModal(flag, tab))
  }
}
export default connect(null, mapDispatchToProps)(FormIdea)



// WEBPACK FOOTER //
// ./src/components/formIdea/index.jsx